import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getReturnForShippingClaim = {
  name: "getReturnForShippingClaim" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    recipientEmail: z.string().nullish(),
    recipientPhone: z.string().nullish(),
    lineItems: z
      .array(
        z.object({
          title: z.string(),
          productTitle: z.string().nullish(),
          variantTitle: z.string(),
          sku: z.string().nullish(),
          quantity: z.number(),
          price: z.string(),
        }),
      )
      .nullish(),
  }),
};
